import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import { PlatformError } from 'lib/graphql/generated';

const hasExpiredCreditCardError = (errors: Array<PlatformError> | undefined | null) => {
  return !isEmpty(errors) && !!find(errors, { code: 'payment_failed_credit_card_expired' });
};

export default hasExpiredCreditCardError;
